<template>
  <div class="max-width">
    <v-row class="my-4">
      <AdminUserFilter
        class="max-width"
        @search="search($event)"
        @add="add($event)"
        @clear="clear($event)"
      />
    </v-row>
    <v-row class="my-4">
      <AdminUserList
        class="max-width"
        :user-list="userList"
        @detail="detail($event)"
        @del="del($event)"
      />
    </v-row>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import AdminUserFilter from './M0001AdminUserFilter.vue'
import AdminUserList from './M0001AdminUserList.vue'
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'

export default {
  name: 'UserSearch',
  components: {
    AdminUserFilter,
    AdminUserList
  },
  mixins: [ErrorDisplay],
  props: {
    userList: {
      type: Array,
      default: () => { return [] }
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    search (event) {
      this.$emit('search', event)
    },
    detail (event) {
      this.$emit('detail', event)
    },
    add (event) {
      this.$emit('add', event)
    },
    del (event) {
      this.$emit('del', event)
    },
    clear (event) {
      this.$emit('clear', event)
    }
  }
}
</script>

<style scoped>
.max-width {
  width: 100%
}
</style>
